import React, { PureComponent } from 'react';
// import { NavLink } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import ProviderCmp from '../../shared/components/providers/provider-cmp';

export default class EditProviderPage extends PureComponent {

  constructor() {
    super();
    this.state = {
      provider_id: ''
    };
  }

  componentDidMount(){
    const { match } = this.props
    this.setState({provider_id: (match && match.params) ? match.params.providerId : '' })
  }

  render(){
    return (<Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Fournisseur</h3>
        </Col>
        <Col md={12}>
          <ProviderCmp editing={true} match={this.props.match} provider_id={this.state.provider_id} history={this.props.history}/>
        </Col>
      </Row>
    </Container>)
  }
}